import React from 'react';
import { FileQuestion, Search, Calendar, DollarSign, Users, Award } from 'lucide-react';
import { Button } from './button';

const iconMap = {
  search: Search,
  calendar: Calendar,
  dollar: DollarSign,
  users: Users,
  award: Award,
  default: FileQuestion
};

const EmptyState = ({ 
  icon = 'default', 
  title = 'No data found', 
  description = 'There are no items to display at this time.',
  action,
  actionLabel = 'Get Started',
  onAction
}) => {
  const Icon = iconMap[icon] || iconMap.default;
  
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="bg-gray-100 rounded-full p-6 mb-4">
        <Icon className="h-12 w-12 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-500 mb-6 max-w-md">{description}</p>
      {action && (
        <Button onClick={onAction} className="bg-teal-600 hover:bg-teal-700">
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
